import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DatePipe } from "@angular/common";

@Pipe({
  name: "localizedDate",
  pure: false,
  standalone: false,
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(
    private translateService: TranslateService,
    private datePipe: DatePipe,
  ) {}

  transform(
    value: string | number | Date,
    pattern: string = "longDate",
  ): string | null {
    return this.datePipe.transform(
      value,
      pattern,
      undefined,
      this.translateService.currentLang,
    );
  }
}
